import R from 'ramda';

const getEmailVerified = R.pathOr(false, [
  'activationModal',
  'sendVerificationEmail',
  'emailVerified',
]);

export default getEmailVerified;
